/**
 * API base URL configuration.
 *
 * In development: VITE_API_URL is unset, so this defaults to '' (empty string).
 *   The Vite dev server proxy forwards /api/* to the local Worker dev server.
 *
 * In production: Set VITE_API_URL to the Worker origin,
 *   e.g. "https://surfsnaps-api.your-subdomain.workers.dev" (no trailing slash).
 *   All fetch calls become cross-origin to the Cloudflare Worker.
 */
export const API_BASE = import.meta.env.VITE_API_URL ?? '';

/**
 * Helper to build a full API URL from a path.
 * @param path - must start with '/' (e.g. '/api/photos/browse')
 */
export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}
